import React, { useState, useRef } from 'react';
import { Box, Typography, Avatar, Container } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay, Pagination } from 'swiper/modules';
import face1 from '../assets/face1.webp';
import face2 from '../assets/face2.webp';
import face3 from '../assets/face3.webp';
import face4 from '../assets/face4.webp';
import face5 from '../assets/face5.webp';
import face6 from '../assets/face6.webp';

const Testimonials = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const swiperRef = useRef(null);

    const dummyTestimonials = [
        {
            name: 'Meenakshi Meher',
            designation: 'Property Buyer, Gachibowli',
            description:
                'From the first consultation to the final handover, the entire property buying process was smooth and stress-free. The team provided expert advice, timely updates, and went the extra mile to ensure I found the perfect home in Gachibowli. Truly exceptional service that exceeded all my expectations!',
            image: face1,
        },
        {
            name: 'Bharath Kumar',
            designation: 'CEO, Example Corp',
            description:
                'This service is absolutely amazing. The professionalism, dedication, and responsiveness of the team stood out right from the start. They delivered exactly what we needed and ensured every milestone was met on time. I would highly recommend them to anyone looking for reliable solutions.',
            image: face2,
        },
        {
            name: 'Shiva Reddy',
            designation: 'Marketing Manager',
            description:
                'Working with this team has been a pleasure. They were professional, efficient, and always open to feedback. Their expertise in the field helped us achieve great results in a short time, and the collaborative experience made the entire process enjoyable and rewarding.',
            image: face3,
        },
        {
            name: 'Venkat Sai',
            designation: 'Product Designer',
            description:
                'The team took the time to deeply understand our product vision and transformed it into a beautifully designed solution. Their attention to detail and creative approach truly set them apart. I felt heard, supported, and inspired throughout the entire journey.',
            image: face4,
        },
        {
            name: 'Lakshmi Narayanan',
            designation: 'Entrepreneur, Chennai',
            description:
                'Their dedication and tailored approach made all the difference. As an entrepreneur, I appreciated their focus on practical solutions and timelines. I look forward to working with them again on future projects.',
            image: face5,
        },
        {
            name: 'Anitha Rajendran',
            designation: 'Software Engineer, Bengaluru',
            description:
                'The experience was seamless and highly professional. The team was always available for clarifications and guided me with great patience. It\'s rare to find such reliable service in today\'s fast-paced world.',
            image: face6,
        },
    ];

    const totalSlides = dummyTestimonials.length;
    const slidesPerView = 2; // For desktop
    const totalPages = Math.ceil(totalSlides / slidesPerView);

    const handlePaginationClick = (pageIndex) => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideTo(pageIndex * slidesPerView);
        }
    };


    return (
        <Box>
            <Box sx={{ bgcolor: '#F5F5F5', py: 5 }}>
                <Container maxWidth="xl">
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 4 }}>
                        <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>  Testimonials </Typography>
                    </Box>

                    <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={30}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            0: { slidesPerView: 1, slidesPerGroup: 1 },
                            600: { slidesPerView: 2, slidesPerGroup: 2 },
                            960: { slidesPerView: 2, slidesPerGroup: 2 },
                        }}
                        onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
                        style={{ paddingBottom: '25px' }}
                        loop={false}
                        allowTouchMove={true}
                        ref={swiperRef}
                        watchSlidesProgress={true}
                    >
                        {dummyTestimonials.map((testimonial, index) => (
                            <SwiperSlide key={index}>
                                <Box sx={{
                                    maxWidth: 550, maxHeight: 250, backgroundColor: '#ffffff', borderRadius: '2px',
                                    p: 3, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 3,
                                }}>
                                    <Typography variant="body1"
                                        sx={{
                                            fontSize: '15px', color: '#333', lineHeight: 1.6, overflow: 'hidden', textOverflow: 'ellipsis',
                                            display: '-webkit-box', WebkitLineClamp: 6, WebkitBoxOrient: 'vertical',
                                        }}
                                    > {testimonial.description}
                                    </Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                        <Avatar src={testimonial.image} alt={testimonial.name} sx={{ width: 56, height: 56, mr: 2 }} />
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '15px', color: '#CB4422', }}>
                                                {testimonial.name}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'gray', fontSize: '13px', }}> {testimonial.designation} </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Custom Static Pagination */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 4 }}>
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Box key={index}
                                sx={{
                                    width: 36, height: 3, cursor: 'pointer',
                                    bgcolor: activeSlide >= index * slidesPerView && activeSlide < (index + 1) * slidesPerView ? '#CB4422' : '#ccc',
                                    borderRadius: 2, transition: 'background-color 0.3s',
                                }}
                                onClick={() => handlePaginationClick(index)}
                            />
                        ))}
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default Testimonials;
